import {
  useDeleteMutation,
  useGetQuery,
  useLazyGetQuery,
  usePostMutation,
  usePutMutation,
} from "slices/api";
import { CHATBOT } from "tagTypes";

export const useQuestionsQuery = (query = {}) =>
  useGetQuery({
    endpoint: "/question",
    query,
    tags: [CHATBOT],
  });

export const useLazyQuestionsQuery = () => {
  const [getChatBotQuestions, data] = useLazyGetQuery();
  const botQuestions = async (query = {}) =>
    await getChatBotQuestions(
      {
        endpoint: "/question",
        query,
        tags: [CHATBOT],
      },
      true
    ).unwrap();
  return [botQuestions, data];
};

export const useQuestionQuery = (questionId, query = {}) =>
  useGetQuery({
    endpoint: `/question/${questionId}`,
    query,
    tags: [CHATBOT],
  });

export const useLazyQuestionQuery = () => {
  const [getChatBotQuestion, data] = useLazyGetQuery();
  const botQuestion = async (questionId, query = {}) =>
    await getChatBotQuestion(
      {
        endpoint: `/question/${questionId}`,
        query,
        tags: [CHATBOT],
      },
      true
    ).unwrap();
  return [botQuestion, data];
};

export const useConversationQuery = (systemId) =>
  useGetQuery({
    endpoint: `/conversation/${systemId}`,
    tags: [CHATBOT],
  });

export const useLazyConversationQuery = () => {
  const [getChatBotConversation, data] = useLazyGetQuery();
  const botConversation = async (systemId) =>
    await getChatBotConversation(
      {
        endpoint: `/conversation/${systemId}`,

        tags: [CHATBOT],
      },
      true
    ).unwrap();
  return [botConversation, data];
};

export const usePostQuestionAnswerMutation = () => {
  const [addQuestionAnswer, data] = usePostMutation();
  const addConversation = async (questionId, payload, query = {}) =>
    await addQuestionAnswer({
      endpoint: `/question/${questionId}/question-answer`,
      query,
      payload: payload || {},

      tags: [CHATBOT],
    }).unwrap();
  return [addConversation, data];
};

export const useDeleteChatConversionMutation = () => {
  const [deleteConversion, data] = useDeleteMutation();
  const clearChatbotConversion = async (systemId) => {
    return await deleteConversion({
      endpoint: `conversation/${systemId}`,
      tags: [CHATBOT],
    }).unwrap();
  };
  return [clearChatbotConversion, data];
};

export const usePostAddConversationMutation = () => {
  const [addBotConversation, data] = usePostMutation();
  const addConversation = async (payload, query = {}) =>
    await addBotConversation({
      endpoint: "/add-conversation",
      query,
      payload: payload || {},
      toastMessage: "Conversation added successfully",
      tags: [CHATBOT],
    }).unwrap();
  return [addConversation, data];
};

export const usePostAddQuestionMutation = () => {
  const [addBotQuestion, data] = usePostMutation();
  const addQuestion = async (payload, query = {}) =>
    await addBotQuestion({
      endpoint: "/add-question",
      query,
      payload: payload || {},
      toastMessage: "Question added successfully",
      tags: [CHATBOT],
    }).unwrap();
  return [addQuestion, data];
};

export const usePostAddAnswerMutation = () => {
  const [addBotAnswer, data] = usePostMutation();
  const addAnswer = async (payload, query = {}) =>
    await addBotAnswer({
      endpoint: "/add-answer",
      query,
      payload: payload || {},
      toastMessage: "Answer added successfully",
      tags: [CHATBOT],
    }).unwrap();
  return [addAnswer, data];
};

export const usePutQuestionMutation = () => {
  const [updateBotQuestion, data] = usePutMutation();
  const updateQuestion = async (payload, id, query = {}) =>
    await updateBotQuestion({
      endpoint: `/question/${id}`,
      query,
      payload: payload || {},
      toastMessage: "Question updated successfully",
      tags: [CHATBOT],
    }).unwrap();
  return [updateQuestion, data];
};

export const usePutAnswerMutation = () => {
  const [updateBotAnswer, data] = usePutMutation();
  const updateAnswer = async (payload, id, query = {}) =>
    await updateBotAnswer({
      endpoint: `/answer/${id}`,
      query,
      payload: payload || {},
      toastMessage: "Answer updated successfully",
      tags: [CHATBOT],
    }).unwrap();
  return [updateAnswer, data];
};
